import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '@eng-dx-gpt/loading';
import { SKIP_LOADER } from '@eng-dx-gpt/api-client';
import { finalize } from 'rxjs';

export const httpLoaderInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const loadingService = inject(LoadingService);
    const skipLoader = req.context.get(SKIP_LOADER);

    if (!skipLoader) {
        loadingService.showLoader();
    }

    return next(req).pipe(
        finalize(() => {
            if (!skipLoader) {
                loadingService.hideLoader();
            }
        })
    );
};
